import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OBJECTIVE_STATUS_CHIP_LABELS } from '../../utils/const';

const defaultConfig = { direction: 'descending', key: 'created_at' };

export function useSortableData (items, config = defaultConfig) {
  const { t } = useTranslation();
  const [ sortConfig, setSortConfig ] = useState(config);
  const sortedItems = useMemo(() => {
    const sortByStatus = [
      t(OBJECTIVE_STATUS_CHIP_LABELS['PROPOSED']),
      t(OBJECTIVE_STATUS_CHIP_LABELS['DECLINED']),
      t(OBJECTIVE_STATUS_CHIP_LABELS['PASSIVE']),
      t(OBJECTIVE_STATUS_CHIP_LABELS['ACTIVE']),
      t(OBJECTIVE_STATUS_CHIP_LABELS['FAILED']),
      t(OBJECTIVE_STATUS_CHIP_LABELS['COMPLETED'])
    ];
    let sortableItems = [ ...items ];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (sortConfig.key === 'status') {
          a = sortByStatus.indexOf(t(OBJECTIVE_STATUS_CHIP_LABELS[
            a[sortConfig.key].toUpperCase()]));
          b = sortByStatus.indexOf(t(OBJECTIVE_STATUS_CHIP_LABELS[
            b[sortConfig.key].toUpperCase()]));
        } else {
          a = (sortConfig.key === 'created_at' || sortConfig.key === 'deadline') ?
            new Date( a[sortConfig.key]) : a[sortConfig.key];
          b = (sortConfig.key === 'created_at' || sortConfig.key === 'deadline') ?
            new Date( b[sortConfig.key]) : b[sortConfig.key];
        };

        if (a < b) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a > b) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [ items, sortConfig, t ]);

  const requestSort = key => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'descending'
    ) {
      setSortConfig(defaultConfig);
    } else if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
      setSortConfig({ key, direction });
    } else {
      setSortConfig({ key, direction });
    }
  };

  return { items: sortedItems, requestSort, sortConfig };
};